// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_mv-5";
export var filledCircle = "_mv-4";
export var historyEntry = "_mv-3";
export var messageSideLeft = "_mv-1";
export var messageSideRight = "_mv-2";
export var orderTrackingCarouselWrapper = "_mv-6";
export var orderTrackingInfoContainer = "_mv-0";